import type { LoaderFunctionArgs } from 'react-router';
import ROUTES, { type PromiseLoaderReturnType } from '@/routes';

import { useMessageStore } from '@/stores/message';
import { getSessionById } from '@/utils/cache-session';
import checkIsSubRoute from '@/utils/check-sub-route';
import { generateSessionKey } from '@/utils/session';

export function groupMessagesLayoutLoader({ params, request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const { searchParams } = url;
  const { search } = ROUTES.MESSAGES.GROUPS.$deserializeSearchParams(searchParams);
  const { id } = ROUTES.MESSAGES.GROUPS.$deserializeParams(params);

  const currentPath = url.pathname;
  const exactPath = ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id } });

  if (checkIsSubRoute(currentPath, exactPath)) return;

  return handleDisplayGroupMessages(id, search);
}

export async function handleDisplayGroupMessages(id: number, search?: number) {
  const sessionInfo = getSessionById('group', id);
  const sessionKey = generateSessionKey('group', id);

  const searchId = useMessageStore.getState().searchId;
  const currentSessionKey = useMessageStore.getState().key;
  const lastReadId = sessionInfo?.SessionType === 'group' ? sessionInfo.ReadGroupChatID : 0;
  const isSameSessionAndSearch = currentSessionKey === sessionKey && searchId === search;

  // NOTE: 修正搜尋模式進入聊天室後，再切換回一般進入聊天室，因 searchId 未正確更新而導致撈了搜尋模式的訊息
  //       透過提前設置 searchId，否則如果由 hydate 執行會有時間差。
  if (!isSameSessionAndSearch) useMessageStore.setState((s) => ({ ...s, searchId: search }));

  const timestamp = Date.now();
  useMessageStore.setState({ listKey: timestamp });
  return {
    promises: isSameSessionAndSearch
      ? Promise.resolve(true)
      : useMessageStore.getState().hydrate({
          type: 'group',
          id,
          searchId: search,
        }),
    initialUnreadCount: sessionInfo?.UnReadCount ?? 0,
    lastReadId,
  };
}

export type GroupMessagesLayoutLoaderReturnType = PromiseLoaderReturnType & {
  initialUnreadCount: number;
  lastReadId: number;
};
